module.exports = __webpack_public_path__ + "img/refPansementCVC.5b0eb3f0.jpg";